import { render } from "./Logout.vue?vue&type=template&id=5c0246a8"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"
script.render = render

export default script